export { default } from './Popper';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Popper/index.js
// module id = 251
// module chunks = 0